module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAoElEQVQokbWSMQrCQBQFR2NnayHewQuIWAlWNpYpvYYnsZE0HkS8iIWCrUUa0YykSAgiuxB14Df7dor/dmmN2pxE3amFYbJ3aR8RalpJRqSLOlNz9a6u1GMV9oAtkH7oaARMgSUwBMq7kyrsqA8gCZQ7Bq7ACehXh10gC0gbYAAsgDVQ1Elgx7M6V2/qU03Vw09a/eodm3L5c2KEevkHwAu7r64I5zVcEQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sipicon/index_phone_del.png
// module id = cERE
// module chunks = 4